import * as api from '@api';
import { useEffect } from 'react';
import { useQuery } from '@/hooks/useApi';
import useToast from '@/hooks/useToast';

const EMPTY = [];

/** Every product category, for the category dropdowns. */
export default function useProductCategoriesDropdown() {
  const { toast } = useToast();

  const { data: response } = useQuery(
    'productCategoriesList',
    () => api.backend.productCategoriesList(),
    { gcTime: 24 * 3600 * 1000 },
  );

  useEffect(() => {
    if (response?.status >= 400) toast.error(response.error.message);
  }, [response, toast]);

  return response?.status < 400 ? (response.data?.data ?? EMPTY) : EMPTY;
}
